module.exports = {
  id: "allkindsstaging",
  title: "Allkinds",
  description:
    "Say hello to awesome: all kinds of bath, body, haircare, skincare & fun stuff made just for kids. And with zero gross stuff.",
  url: "staging.allkinds.com",
  subfolder: "",
  locationCurrencyCode: "AUD",
  locationRegion: "AU",
  locationRegionFullName: "Australian",
  locationCountries: "AU,NZ",
  locationForceRegion: true,
  locationLookupUrl: "https://ipapi.co/json/?key=Di68RWc6asPYru3MCgBD5bAZIMWaQwIFirSSKxUNjtwx9xDVnU",

  shopifyPlus: false,
  shopifyApiVersion: "2026-01",
  shopifyShopName: "allkinds-shop",
  shopifyShopDomain: "allkinds-shop.myshopify.com",
  brazeCatalogName: "allkinds-shop_shopify_catalog",
  shopifyCheckoutUrl: "checkout.staging.allkinds.com",
  shopifyStorefrontToken: "ff9d3174b85c6c28b27be458d5391c71",
  shopifyMetafieldIdStoreSync: "16222736580770",
  minimumOrderValue: 0,

  googleSheetsSpreadsheetId: "1VhEb12HgZJ9bOY2GIZ1Xaa9ebj6z4WuZWOXPVIlvvds",
  googleSheetsSheetId: "Staging",
  giftCardType: "Gift Card",

  sanityProjectId: "3oef59p4",
  sanityDataset: "staging",
  sanityApiVersion: "2022-02-24",
  sanityToken:
    "skBoBI9fgEuAQxyYIWmwR1UaOXiCCkSLD69ce0lIIQazPjGb81Kb87Am9yIo8thtIFJjcLMY6IPwkU3DqlpPg98JkQ75CbhNfrKTvMRZi3dVbaKhAK2g6IkIxu5uzOlsaycOiBKBQIb39QN7yttUYYA12yGL31xhdYQ9OVNwRr2vjfA41fMJ",

  searchConfig: "https://config.search.reactify.app?shop=allkinds-shop.myshopify.com",
  tolstoyAppKey: "321b64bb-f483-4f59-8dc1-103ecf11d1b4",

  mapboxAccessToken: "pk.eyJ1IjoiYnJhbmRiYW5rIiwiYSI6ImNsOTNkYnVsOTAxZmozdnIyNDN0ZjhzanEifQ.rRjLiL_nVNUjPcGxkSfHKA",
  stockBrand: "AKAU",
  stockServiceUrl: "https://devapi.brandbank.com.au/inventory/v2/findinstore",
  flowProxyEndpoint: "https://devapi.brandbank.com.au",
  balanceURL: "/give-x/v2/give-x",
  givexBrand: "allkinds-au",
  givexEndpoint: "https://bb-giftcard-staging-fhgwaeg4euckgjbc.australiaeast-01.azurewebsites.net",

  functionAppDomain: "allkinds-au-functions-staging.fly.dev",

  wishlistPlusStorefrontEndpoint: "https://swymstore-v3pro-01.swymrelay.com/api/",
  wishlistPlusAdminEndpoint: "https://swymstore-v3pro-01.swymrelay.com/storeadmin/v3/user/",
  wishlistPlusApiKey: "eQf3nfASpmqiZ9SE1WNuwi7nbIMI2QM8kd3d8SHAvsvLOzHX1wYj29wtTFZczUmBokjNw5HeHjn0f7AtivJt8Q",
  wishlistPlusPid: "zJelcwfawKGUOXv1okZFcFSbmNqBlA9GoxaxlqV0aqQ=",
  yotpoAppKey: "kt4oD4Qg0weICKK2KBjsnivgdeuq3gnk4GiwswQQ",
}
